<template>
  <div>
    <main>
      <section class="shop">
        <i class="fas fa-address-book"></i>
        <h1>Contact Info</h1>
      </section>

      <form class="contact-form" @submit.prevent="submitForm">
        <div class="form-group">
          <label for="email">Email Address</label>
          <input v-model="email" type="email" id="email" required placeholder="e.g. artren@quiltanarchy.xyz" />
        </div>

        <div class="form-group">
          <label for="discord">Discord Username</label>
          <input v-model="discord" type="text" id="discord" required placeholder="e.g. artren" />
        </div>

        <button class="next-btn" type="submit">Next</button>
      </form>
    </main>
  </div>
</template>

<script>
export default {
  name: 'DeliveryStage',
  props: {
    formData: Object
  },
  data() {
    return {
      email: '',
      discord: ''
    }
  },
  methods: {
    submitForm() {
      const formData = {
        email: this.email,
        discord: this.discord
      }

      this.$emit('updateForm', formData)
      this.$emit('next')
    }

  }
}
</script>

<style scoped>
main {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 2rem;
  color: #fff;
}

.shop {
  width: 100%;
  max-width: 400px;
  margin: 3rem 0;
  padding: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  border-bottom: 5px solid cornflowerblue;
}

.shop i {
  margin-right: 1rem;
  font-size: 2rem;
  cursor: pointer;
}

.shop h1 {
  text-transform: uppercase;
  font-size: 2.2rem;
  font-weight: 500;
  letter-spacing: 1px;
}

.contact-form {
  background-color: #222;
  padding: 2rem;
  border-radius: 10px;
  border: 2px solid #444;
  width: 100%;
  max-width: 500px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
}

.form-group {
  margin-bottom: 1.5rem;
  text-align: left;
}

label {
  display: block;
  margin-bottom: 0.5rem;
  font-size: 1.1rem;
  color: cornflowerblue;
}

input {
  width: 100%;
  padding: 0.7rem;
  border-radius: 6px;
  border: 1px solid #555;
  background-color: #111;
  color: #fff;
  font-size: 1rem;
}

.next-btn {
  margin-top: 1rem;
  padding: 0.8rem 2rem;
  background-color: cornflowerblue;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  cursor: pointer;
  transition: background 0.3s ease;
}

.next-btn:hover {
  background-color: royalblue;
}
</style>
